import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    retrospectList: () => {
        return HTTP.get('/orderwebpage/reverse_order', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}